<template>
  <div class="userSettings">
    <div class="loginOutBox" @click="loginOut">
      <div class="loginOut">
        <van-image width="20" height="20" :src="logout"></van-image>
        <span class="label">{{ $t.auth.logout }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import { LOG_OUT } from "@/store/mutation-types";
import { Image } from "vant";

import Vue from "vue";
Vue.use(Image);
export default {
  name: "userSettings",
  data() {
    return {
      logout: require("@/assets/img/userManage/logout.png"),
    };
  },
  methods: {
    ...mapMutations([LOG_OUT]),
    loginOut() {
      this.LOG_OUT();
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "auth/login",
        name: "Login",
        query: [],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.userSettings {
  margin: 15px 10px 10px 10px;
  .loginOutBox {
    .loginOut {
      box-shadow: 0px 2px 10px 2px rgb(0 0 0 / 10%);
      border: 1px solid red;
      border-radius: 10px;
      padding: 4% 0;
      text-align: center;
      color: red;
      font-size: 14px;
      font-weight: 500;
      .van-image {
        vertical-align: middle;
      }
      .label {
        vertical-align: middle;
        margin-left: 5px;
        line-height: 20px;
        height: 20px;
        display: inline-block;
      }
    }
  }
}
</style>
